import { CustomColumnType } from "../grid-column-types";
import { getRowsToExport } from "./cellExporter";
import { rowColors, sparklineColumnSize, tableParams } from "./constants";
import { getFooterToExport, getHeaderToExport } from "./rowsExporter";
const createLayout = (numberOfHeaderRows) => ({
    fillColor: (rowIndex) => {
        if (rowIndex < numberOfHeaderRows) {
            return rowColors.HEADER_ROW_COLOR;
        }
        return rowIndex % 2 === 0 ? rowColors.EVEN_ROW_COLOR : rowColors.ODD_ROW_COLOR;
    },
    hLineColor: (rowIndex, node) => (rowIndex === 0 || rowIndex === node.table.body.length - 1
        ? rowColors.PDF_OUTER_BORDER_COLOR
        : rowColors.PDF_INNER_BORDER_COLOR),
    hLineWidth: (rowIndex, node) => (rowIndex === node.table.body.length ? 0 : tableParams.BORDER_WIDTH),
    vLineColor: (rowIndex, node) => (rowIndex === 0 || rowIndex === node.table.widths.length
        ? rowColors.PDF_OUTER_BORDER_COLOR
        : rowColors.PDF_INNER_BORDER_COLOR),
    vLineWidth: (rowIndex, node) => (rowIndex === node.table.body.length - 1 ? 0 : tableParams.BORDER_WIDTH)
});
export const getDocument = (gridApi, rowDataCount, dataScale, pageAvailableWidth) => {
    const headerRow = getHeaderToExport(gridApi);
    const sparklineColumnCount = headerRow.columnsInHeaderSecondRow.filter((x) => x.type === CustomColumnType.InsSparklineColumn).length;
    const sparklineColumnPercentage = pageAvailableWidth ? Math.ceil((sparklineColumnSize.WIDTH / pageAvailableWidth) * 100) : 0;
    const totalAvailablePorcentage = 100 - (sparklineColumnCount * sparklineColumnPercentage);
    const numberOfColumns = headerRow.columnsInHeaderSecondRow.length - sparklineColumnCount;
    const widths = headerRow.columnsInHeaderSecondRow.map((x) => {
        if (x.type === CustomColumnType.InsSparklineColumn) {
            return `${sparklineColumnPercentage}%`;
        }
        return `${totalAvailablePorcentage / numberOfColumns}%`;
    });
    const rows = getRowsToExport(gridApi, dataScale);
    const footer = getFooterToExport(rowDataCount, headerRow.columnsInHeaderSecondRow.length);
    return {
        content: [
            {
                layout: createLayout(2),
                table: {
                    body: [headerRow.columnsInHeaderFirstRow, headerRow.columnsInHeaderSecondRow, ...rows, footer],
                    dontBreakRows: true,
                    headerRows: 2,
                    heights: (rowIndex) => (rowIndex === 0 ? tableParams.HEADER_HEIGHT : tableParams.CELL_HEIGHT),
                    widths
                }
            }
        ]
    };
};
